import SocialActivityAction from 'components/SocialActivityAction';
import PostHeader from 'components/PostHeader';
import PostDescription from 'components/PostDescription';
import LinkpostContent from 'components/LinkpostContent';
import SocialActivity from 'components/SocialActivity';
import useSingleAndDoubleClick from 'hooks/useSingleAndDoubleClick';
import { useState } from 'react';
import { IPostPageLinkPost } from './IPostPageLinkPost';

import {
  PostPageLinkPostWrapper,
  MediaWrapper,
  SocialActivityBlock,
} from './PostPageLinkPost.styles';

const PostPageLinkPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  isClickable,
  link,
  linkImage,
  linkTitle,
  linkHost,
  origin,
  users,
  groups,
  events,
  text,
  locationName,
  isLike,
  likes,
  id,
  originId,
  commentsCount,
  sharesCount,
  data,
  onCommentClick,
  onLikesCountClick,
  onLikeClick,
  geoLocation
}: IPostPageLinkPost) => {
  const [isPageLinkUrlCopied, setIsPageLinkUrlCopied] =
    useState<boolean>(false);

  const handleOnPhoto = useSingleAndDoubleClick(
    () => {
      window.open(link, '_blank');
    },
    () => {
      onLikeClick(id);
    }
  );

  return (
    <PostPageLinkPostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={3}
        id={id}
        originId={originId}
        data={data}
      />
      {(text ||
        groups?.length ||
        users?.length ||
        events?.length ||
        locationName) && (
        <PostDescription
          origin={origin}
          users={users}
          groups={groups}
          events={events}
          text={text}
          locationName={locationName}
          type={3}
          geoLocation={geoLocation}
        />
      )}

      <MediaWrapper isClickable={isClickable} onClick={handleOnPhoto}>
        <LinkpostContent
          linkImage={linkImage}
          linkTitle={linkTitle}
          linkHost={linkHost}
          description={text}
        />
      </MediaWrapper>
      <SocialActivityBlock>
        <SocialActivity
          id={id}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={onLikeClick}
          onLikesCountClick={(id) => onLikesCountClick(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likes}
          isLike={isLike}
          type="post"
          postType={3}
          isUrlCopied={isPageLinkUrlCopied}
          setIsUrlCopied={setIsPageLinkUrlCopied}
        />
      </SocialActivityBlock>
    </PostPageLinkPostWrapper>
  );
};

export default PostPageLinkPost;
